<template lang="pug">
    v-content
        SignupCard
        SignUpForm
</template>

<script>

import SignupCard from "../components/SignupCard.vue";
import SignUpForm from "../components/FormSignUp.vue";
export default {
  components: {
    SignupCard,
    SignUpForm
  }
};
</script>

<style>
.bg {
 /* background: url("../assets/bliss.jpg");*/
  background-size: cover;
}
</style>
